import React from "react";

import { capitalizeCategory } from "../../utils/utils";

const CategorySelect = ({ currentCategory, changeCategory, categories }) => {
  return (
    <section className="category-select">
      <select
        id="voices"
        value={currentCategory}
        onChange={(e) => changeCategory(e.target.value)}
      >
        {categories.map((category, key) => {
          return (
            <option key={key} value={category.category}>
              {capitalizeCategory(category.category)}
            </option>
          );
        })}
      </select>
    </section>
  );
};

export default CategorySelect;
